module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "class-edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("班级班级\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账号:",
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "label-width",
    attrs: {
      "placeholder": "请填写正确的账号",
      "disabled": ""
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "昵称:",
      "prop": "showName"
    }
  }, [_c('el-input', {
    staticClass: "label-width",
    attrs: {
      "placeholder": "请填写正确的昵称",
      "disabled": ""
    },
    model: {
      value: (_vm.form.showName),
      callback: function($$v) {
        _vm.$set(_vm.form, "showName", $$v)
      },
      expression: "form.showName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "行政班级:"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.checkAll
    },
    model: {
      value: (_vm.isCheckAll),
      callback: function($$v) {
        _vm.isCheckAll = $$v
      },
      expression: "isCheckAll"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("全选")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "departs"
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "width": "50%"
    },
    model: {
      value: (_vm.form.departs),
      callback: function($$v) {
        _vm.$set(_vm.form, "departs", $$v)
      },
      expression: "form.departs"
    }
  }, _vm._l((_vm.departs), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id,
        "value": "item.id"
      }
    }, [_vm._v(_vm._s(item.department))])
  }), 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d089a60!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiaoyuan/GX/editClass.vue
// module id = 979
// module chunks = 0